import { configureStore } from "@reduxjs/toolkit";
import { INITIAL_STATE, WAREHOUSE_URL } from "constants/AppConstants";
import { AuthorizationToken } from "helpers/AuthorizationToken";
import { getCompressedItem } from "helpers/compressedStorage";
import fleetlogicAPI from "helpers/fleetlogicAPI";
import { setCurrentUser } from "../actions/authActions";
import reducer from "../reducers";

const store = configureStore({
  reducer,
  preloadedState: INITIAL_STATE,
  middleware: getDefaultMiddleware => getDefaultMiddleware(),
  devTools: true
});

const currentUserRaw = getCompressedItem("currentUser");
if (localStorage.jwtToken && currentUserRaw) {
  AuthorizationToken.set(localStorage.jwtToken);
  try {
    let user = JSON.parse(currentUserRaw);
    store.dispatch(setCurrentUser(user));
    if (user.divisions === undefined) {
      fleetlogicAPI.get(WAREHOUSE_URL).then(res => {
        const updatedUser = { ...user, divisions: res.data.results };
        store.dispatch(setCurrentUser(updatedUser));
      });
    }
  } catch(error) {
    console.error("Error parsing user data:", error);
  }
}
// @ts-ignore
window.store = store;

export default store;
